import CallBackForm from '@/components/HomePage/CallBackForm';
import { Modal } from 'antd';
import React, { Dispatch, FC, SetStateAction } from 'react';

interface Props {
  open: boolean;
  onOk?: ((e: React.MouseEvent<HTMLButtonElement>) => void) | undefined;
  onCancel?: ((e?: React.MouseEvent<HTMLButtonElement>) => void) | undefined;
  setLoading: Dispatch<SetStateAction<boolean>>;
  loading: boolean;
  onSuccess: () => void;
}

const CallBackFormModal: FC<Props> = ({
  open,
  onOk,
  onCancel,
  setLoading,
  loading,
  onSuccess,
}) => {
  return (
    <Modal
      title='Enter your Details'
      closable={{ 'aria-label': 'Custom Close Button' }}
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      footer={null}
    >
      <CallBackForm
        onSuccess={() => {
          onSuccess();
          onCancel?.();
        }}
        loading={loading}
        setLoading={setLoading}
      />
    </Modal>
  );
};

export default CallBackFormModal;
